// extracted by mini-css-extract-plugin
export default {"MarginLeftAuto":"dropdownCard_MarginLeftAuto_SGZES"};